import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { INote } from '@interfaces/INoteData';
import {
  ICheckingTeacherQParams,
  INoteQParams,
  IStudentQParams,
  ITeacherQParams,
} from '@interfaces/IQParams';
import {
  IStudentFinalResults,
  IStudentGenerateFinalResults,
  IStudentResults,
} from '@interfaces/IStudentResults';
import { ICheckingTeachers, IUser, IUsersPagination } from '@interfaces/IUser';
import { getHttpParams } from '@shared/utils/utils';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UsersViewService {
  constructor(private _http: HttpClient) {}

  getUser(id: number): Observable<IUser> {
    const url = `${environment.baseUrl}api/v1/users/${id}/`;
    return this._http.get<IUser>(url);
  }

  getUsers(queries?: { [key: string]: string }): Observable<IUsersPagination> {
    const url = `${environment.baseUrl}api/v1/users/`;
    return this._http.get<IUsersPagination>(url, { params: queries });
  }

  getStudents(
    groupId: number,
    qParams?: IStudentQParams
  ): Observable<IUsersPagination> {
    const url = `${environment.baseUrl}api/v1/groups/${groupId}/students/`;
    let params = new HttpParams();

    if (qParams) {
      params = getHttpParams({ ...qParams });
    }

    return this._http.get<IUsersPagination>(url, { params });
  }

  getGroupTeachers(
    groupId: number,
    qParams?: ITeacherQParams
  ): Observable<IUsersPagination> {
    const url = `${environment.baseUrl}api/v1/groups/${groupId}/teachers/`;
    let params = new HttpParams();

    if (qParams) {
      params = getHttpParams({ ...qParams });
    }

    return this._http.get<IUsersPagination>(url, { params });
  }

  getGroupCheckingTeachers(
    qParams?: ICheckingTeacherQParams
  ): Observable<ICheckingTeachers[]> {
    const url = `${environment.baseUrl}api/v1/reviewers-groups/`;
    let params = new HttpParams();

    if (qParams) {
      params = getHttpParams({ ...qParams });
    }

    return this._http.get<ICheckingTeachers[]>(url, { params });
  }

  getNoteById(id: number): Observable<INote> {
    const url = `${environment.baseUrl}api/v1/notes/${id}/`;
    return this._http.get<INote>(url);
  }

  getNotes(qParams: INoteQParams): Observable<INote[]> {
    const url = `${environment.baseUrl}api/v1/notes/`;
    let params = new HttpParams();

    if (qParams) {
      params = getHttpParams({ ...qParams });
    }

    return this._http.get<INote[]>(url, { params });
  }

  getGroupsResults(userId: number): Observable<IStudentResults[]> {
    const url = `${environment.baseUrl}api/v1/users/${userId}/groups/results/`;
    return this._http.get<IStudentResults[]>(url);
  }

  generateStudentResults(
    id: number,
    periods: number[]
  ): Observable<IStudentGenerateFinalResults> {
    const url = `${environment.baseUrl}api/v1/users/${id}/results/`;
    return this._http.post<IStudentGenerateFinalResults>(url, {
      user_id: id,
      periods,
    });
  }

  getStudentFinalResults(id: number): Observable<IStudentFinalResults[]> {
    const url = `${environment.baseUrl}api/v1/result_filter/${id}/`;
    return this._http.get<IStudentFinalResults[]>(url);
  }
}
